import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GisDimsMapComponent } from 'src/app/main/shared/gis-dims-map/gis-dims-map.component';
import { DataService } from 'src/app/main/shared/services/data.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-temperature-forecast-sidebar',
  templateUrl: './temperature-forecast-sidebar.component.html',
  styleUrls: ['./temperature-forecast-sidebar.component.scss']
})
export class TemperatureForecastSidebarComponent implements OnInit {

  @Input() labelStrings: any;
  @Input() blockNum: number;
  @Output() playPos = new EventEmitter<any>();
  selected: string;
  queryParams: {};
  isInitialLoad: boolean = false;
  dateIndexLength: any;
  activeRadioList: boolean[] = [];
  modalRef: any;
  sourceOptions: any = ['IMD', 'ECMWF', 'IMD(WRF + GFS)'];
  selectedSource: any;
  moduleName: string;
  sourceMapping = {
    'IMD': 'IMD_LONG_RANGE',
    'ECMWF': 'ECMWF',
    'IMD(WRF + GFS)': 'IMD_SHORT_RANGE'
  }
  destroy: any = new Subject();
  subscriptions: any = [];
  sessionStorage: any = {
    params: {}
  };

  constructor(private router: Router,
    private route: ActivatedRoute,
    private gisUtils: UtilsService,
    private dataService: DataService,
    private gisMapComp: GisDimsMapComponent) {
    this.moduleName = this.router.url.split('/')[1];
    this.selected = this.router.url.split("/")[2]
  }

  // ngOnInit() {
  //   this.route.queryParams.subscribe((params: any) => {
  //     this.queryParams = { ...params };
  //     if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
  //       this.isInitialLoad = true
  //       const normalizedSource = this.queryParams['source'] || 'IMD_LONG_RANGE';
  //       this.selectedSource = normalizedSource == 'IMD_LONG_RANGE' ? 'IMD' : normalizedSource == 'IMD_SHORT_RANGE' ? 'IMD(WRF + GFS)' : normalizedSource,
  //         this.dateIndexLength = this.queryParams['forecastLength'] == '24' ? 9 : 7
  //       for (let i = 0; i < this.dateIndexLength; ++i) {
  //         if (i === this.blockNum) {
  //           this.activeRadioList.push(true);
  //         } else {
  //           this.activeRadioList.push(false);
  //         }
  //       }
  //       this.requestSelectedFilterParams()
  //     }
  //   })
  // }

  ngOnInit() {
    this.isInitialLoad = true;
    this.subscribeEvents()
    this.setParams()
  }

  subscribeEvents() {
    const selectedParamsRef = this.gisUtils.selectedParams.pipe(takeUntil(this.destroy)).subscribe((params: any) => {
      let sessionStorageSelectedParams: any = sessionStorage.getItem('params');
      if (Object.keys(params).length > 0) {
        this.queryParams = params;
      } else {
        this.queryParams = sessionStorageSelectedParams ? JSON.parse(sessionStorageSelectedParams) : {};
        this.sessionStorage.params = { ...this.queryParams };
        if (Object.keys(this.queryParams).length) {
          this.gisUtils.setSelectedParams(this.queryParams);
        }
      }
      if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
        const normalizedSource = this.queryParams['source'] || 'IMD_LONG_RANGE';
        this.selectedSource = normalizedSource == 'IMD_LONG_RANGE' ? 'IMD' : normalizedSource == 'IMD_SHORT_RANGE' ? 'IMD(WRF + GFS)' : normalizedSource,
          this.dateIndexLength = this.queryParams['forecastLength'] == '24' ? 9 : 7
        for (let i = 0; i < this.dateIndexLength; ++i) {
          if (i === this.blockNum) {
            this.activeRadioList.push(true);
          } else {
            this.activeRadioList.push(false);
          }
        }
      }
    });
    this.subscriptions.push(selectedParamsRef)
  }


  setParams() {
    if (this.isInitialLoad && !Object.keys(this.sessionStorage.params).length) {
      this.requestSelectedFilterParams();
    }
    this.isInitialLoad = false;
  }

  ngOnChanges(change: SimpleChanges) {
    // let timeStamp = this.labelStrings[this.blockNum].groupName;
    // this.gisUtils.setTimeStamp(timeStamp)
    if (!isNullOrUndefined(change.blockNum) && Object.keys(this.labelStrings).length > 0) {
      if (change.blockNum.currentValue) {
        this.buttonClicked(change.blockNum.currentValue);
      }

    } else {
      this.buttonClicked(this.blockNum);
    }
    const len = this.activeRadioList.length;
    this.activeRadioList = [];
    for (let i = 0; i < this.dateIndexLength; ++i) {
      if (i === this.blockNum) {
        this.activeRadioList.push(true);
      } else {
        this.activeRadioList.push(false);
      }
    }
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    if (!this.isInitialLoad) {
      currentUrlParams = this.queryParams;
    }
    currentUrlParams['component'] = 'TEMPERATUREFORECAST';
    currentUrlParams['src'] = 'IMD_GRID'
    currentUrlParams['source'] = this.sourceMapping[this.selectedSource]
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'Admin';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      currentUrlParams['dashboardType'] = 'gis';
      const userLocationConfig = this.dataService.formQuerParamsVariables(this.gisMapComp.metaInfo.userDetailsJson.data.location, this.gisMapComp.metaInfo.userDetailsJson.data.locType);
      const currentLocations: any = userLocationConfig.locationInfo[userLocationConfig.types.pType.toLowerCase()].split('##');
      currentUrlParams['pUUID'] = currentLocations[1]
      currentUrlParams['locName'] = currentLocations[0]
      currentUrlParams['locType'] = userLocationConfig.types.pType;
      currentUrlParams['pEUUID'] = userLocationConfig.locationInfo.country.split('##')[1];
      currentUrlParams['location'] = userLocationConfig.locationInfo.location;
      currentUrlParams['source'] = 'IMD_LONG_RANGE'
      currentUrlParams['forecastLength'] = '24'
      this.isInitialLoad = false
    }
    this.gisUtils.setSelectedParams(currentUrlParams);
  }

  buttonClicked(blockNumber, from?: string) {
    if (from === 'HTML') {
      this.playPos.emit(blockNumber);
    }
    if (this.activeRadioList[blockNumber]) {
      this.gisUtils.setIndex(this.labelStrings[blockNumber]['groupName']);
    }
  }

  validate(i) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return ""
    }
    else {
      return this.labelStrings[i]['fullLabel'];
    }
  }

  sourceChange() {
    this.requestSelectedFilterParams()
  }

}
